module.exports = __webpack_public_path__ + "assets/analytics_marker-hover.02e3cc61.svg";